export default {
domainInvalid: {
  siteUnavailableTitle: "사이트를 사용할 수 없습니다",
  siteUnavailableDesc: "현재 이 사이트를 사용할 수 없습니다.",
  contactAdmin: "관리자에게 문의하세요.",
  serverErrorTitle: "서비스를 사용할 수 없습니다",
  serverErrorDesc: "서버에 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.",
  serverErrorTip: "서버가 복구되면 자동으로 다시 연결됩니다.",
  notAuthorizedTitle: "도메인이 승인되지 않았습니다",
  notAuthorizedDesc: "현재 도메인은 이 서비스에 접근할 권한이 없습니다.",
  checking: "확인 중...",
  retry: "다시 시도",
  reload: "새로고침",
  reloading: "새로고침 중...",
  checkingDomain: "도메인 확인 중...",
  authorizedRedirecting: "도메인이 승인되었습니다. 이동 중...",
  stillNotAuthorized: "도메인이 아직 승인되지 않았습니다",
  reconnecting: "재연결 중..."
}
};
